import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import Swal from 'sweetalert2';
import {
  AUTH_COOKIE_KEYS,
  getAuthIdleRemainingMs,
  invalidateAuthSession,
  isAuthSessionValid,
  touchAuthActivity,
} from '../utils/authSession';

const ACTIVITY_EVENTS = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];

function isLoginPath() {
  const path = window.location.pathname || '/';
  return path === '/' || path === '/login' || path.startsWith('/login');
}

function expireIdleSession(removeCookie) {
  invalidateAuthSession(removeCookie);
  if (!isLoginPath()) {
    window.location.replace('/');
    Swal.fire({
      title: 'Session expired',
      text: 'You were logged out after 30 minutes of inactivity. Please sign in again.',
      icon: 'info',
    });
  }
}

export default function AuthIdleWatcher() {
  const [cookies, , removeCookie] = useCookies(AUTH_COOKIE_KEYS);

  useEffect(() => {
    const onActivity = () => {
      if (isAuthSessionValid(cookies.myToken)) {
        touchAuthActivity();
      }
    };

    const checkIdle = () => {
      if (isLoginPath()) {
        return;
      }
      if (!isAuthSessionValid(cookies.myToken) || getAuthIdleRemainingMs() <= 0) {
        expireIdleSession(removeCookie);
      }
    };

    ACTIVITY_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, onActivity, { passive: true });
    });
    document.addEventListener('visibilitychange', checkIdle);
    window.addEventListener('focus', checkIdle);

    checkIdle();
    const intervalId = window.setInterval(checkIdle, 15000);

    return () => {
      ACTIVITY_EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, onActivity);
      });
      document.removeEventListener('visibilitychange', checkIdle);
      window.removeEventListener('focus', checkIdle);
      window.clearInterval(intervalId);
    };
  }, [cookies.myToken, removeCookie]);

  return null;
}
